import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_MDC_STOCK_POSTING_PRODUCT_DETAILS } from '../mdc-stock-posting.api';
import { StockPostingProduct } from '../types/stock-posting-product';

@Injectable()
export class ProductDetailsRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  load(productId: number): Promise<StockPostingProduct> {
    return this.dataAccess.get<StockPostingProduct>({
      path: SOFTLINE_API_MDC_STOCK_POSTING_PRODUCT_DETAILS,
      pathParams: { id: productId },
    });
  }
}
